"use strict";
/**
 * @class SVGHexagonBadge
 * @description hexagon badge svg
 */
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var BadgeLabel_1 = require("./BadgeLabel");
var SVGHexagonBadge = function (_a) {
    var text = _a.text;
    return (React.createElement("svg", { version: "1.1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 100 100", className: "oui__badge-hexagon" },
        React.createElement("polygon", { points: "100,50 75,93 25,93 0,50 25,7 75,7" }),
        React.createElement(BadgeLabel_1.default, { text: text })));
};
exports.default = SVGHexagonBadge;
//# sourceMappingURL=SVGHexagonBadge.js.map